import styled from '@emotion/styled';
import { SerializedStyles } from '@emotion/react';

export interface DividerProps {
  styles?: SerializedStyles;
}

export const Divider = styled.div`
  background: #e0e0e0;
  &[data-orientation='vertical'] {
    width: 1px;
    height: 100%;
  }
  &[data-orientation='horizontal'] {
    width: 100%;
    height: 1px;
  }
  ${(props: DividerProps) => props.styles};
`;
